import React from 'react';
import cn from 'classnames';
import isNil from 'lodash/isNil';
import { FloatingLabel, Label, Hint } from '@progress/kendo-react-labels';

const FilterComponent = ({
  name,
  value,
  onChange,
  label,
  hideLabel = false,
  hint,
  Component,
  disabled,
  onEnterKeyPressed,
  className,
  size = 'normal',
  icon,
  isFloatingLabel = true,
  isToggle = false,
  ...props
}) => {
  const id = `${name}-filter`;
  const labelId = `${id}-label`;
  const hintId = hint ? `${id}-hint` : undefined;

  const handleChange = (e) => onChange(e?.value);

  const filterClassName = cn('filter-item', {
    'filter-item-xxl': size === 'xxl',
    'filter-item-xl': size === 'xl',
    'filter-item-large': size === 'large',
    'filter-item-small': size === 'small',
    'filter-item-xs': size === 'xs',
    'filter-item-toggle': isToggle,
    [className]: className,
  });

  if (isToggle || !isFloatingLabel || hideLabel) {
    return (
      <div className={filterClassName}>
        {(!hideLabel && label) && (
          <Label id={labelId} editorId={id} editorDisabled={disabled}>
            {label}
          </Label>
        )}
        <Component
          id={id}
          ariaDescribedBy={hintId}
          value={value}
          onChange={handleChange}
          disabled={disabled}
          onEnterKeyPressed={onEnterKeyPressed}
          icon={icon}
          dataTestId={id}
          {...props}
        />
        {hint && <Hint id={hintId}>{hint}</Hint>}
      </div>
    );
  }

  return (
    <div className={filterClassName}>
      <FloatingLabel
        label={label}
        id={labelId}
        editorId={id}
        editorDisabled={disabled}
        editorValue={isNil(value) || value?.length === 0 ? null : value.toString()}
      >
        <Component
          id={id}
          ariaDescribedBy={hintId}
          value={value}
          onChange={handleChange}
          disabled={disabled}
          onEnterKeyPressed={onEnterKeyPressed}
          icon={icon}
          dataTestId={id}
          {...props}
        />
      </FloatingLabel>
      {hint && <Hint id={hintId}>{hint}</Hint>}
    </div>
  );
};

export default FilterComponent;
